
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/wixData/components/collectionsSection/collectionsSection.scss.css.virtualfile';
        module.exports = {"sectionHeader":"_sectionHeader_zwhoj_1"};